"use strict";

var ww = $(window).width();
var wh = $(window).height();
var winScrollTop = 0;
var is_sp = false;

if (ww <= 768) {
  is_sp = true;
}
/*----------------------------------------
	loading
----------------------------------------*/


$(window).on("load", function () {
  $(".loading").css({
    "pointer-events": "none"
  });
  gsap.to($(".loading"), 2.5, {
    scale: 1.5,
    autoAlpha: 0,
    ease: Expo.easeOut
  });
});
/*----------------------------------------
	header
----------------------------------------*/

$(function () {
  var header_inner = $(".header-container__inner");
  var header_tag_h = $(".header-container__tagline").outerHeight();
  $(window).scroll(function () {
    winScrollTop = $(window).scrollTop();

    if (winScrollTop >= header_tag_h) {
      header_inner.addClass("is_fixed");
    } else {
      header_inner.removeClass("is_fixed");
    }
  }); //

  $(".inner-scroll").click(function () {
    var href = $(this).attr("href");
    var position = $(href).offset().top;
    $('body,html').stop().animate({
      scrollTop: position
    }, 400);
  });
});
/*----------------------------------------
	main_visual
----------------------------------------*/

gsap.set($(".index-main-visual__bg img"), {
  opacity: 0,
  scale: 1.4
});
gsap.set($(".index-main-visual__inner"), {
  opacity: 0
});
$(window).on("load", function () {
  gsap.to($(".index-main-visual__bg img"), 3, {
    opacity: 1,
    scale: 1,
    ease: Expo.easeOut
  });
  gsap.to($(".index-main-visual__inner"), 6, {
    delay: 1.5,
    opacity: 1,
    ease: Expo.easeOut
  });
  $(window).on('scroll', function () {
    var winScrollTop = $(window).scrollTop();
    $(".index-main-visual__bg").css({
      "top": winScrollTop / 2.8
    });
    $(".index-main-visual__shape").css({
      "transform": "translateY( " + -winScrollTop / 3 + "px)"
    });
  });
});
/*----------------------------------------
	materials
----------------------------------------*/

TweenMax.set($(".index-material-archive__inner ul li"), {
  autoAlpha: 0,
  scale: .8
});
$(window).on("load", function () {
  $(window).scroll(function () {
    winScrollTop = $(this).scrollTop();
    $(".index-material-archive__inner ul").each(function () {
      var elemPos = $(this).offset().top;

      if (winScrollTop > elemPos - wh / 1.5) {
        TweenMax.staggerTo($(this).find("li"), 3, {
          scale: 1,
          autoAlpha: 1,
          ease: Expo.easeOut
        }, .2);
      }
    });
  });
});

/*----------------------------------------
	download img
----------------------------------------*/
function downloadImg (url, name, opts) {
  var xhr = new XMLHttpRequest()
  xhr.open('GET', url)
  xhr.responseType = 'blob'
  xhr.onload = function () {
    saveAs(xhr.response, name, opts)
  }
  xhr.onerror = function () {
    console.error('could not download file')
  }
  xhr.send()
}

